import { render } from "./MaterialDetails.vue?vue&type=template&id=af00922a&scoped=true"
import script from "./MaterialDetails.vue?vue&type=script&lang=js"
export * from "./MaterialDetails.vue?vue&type=script&lang=js"

import "./MaterialDetails.vue?vue&type=style&index=0&id=af00922a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af00922a"]])

export default __exports__